import { HttpClient } from '../../protocols/http/httpClient'
import { validateHttpStatus } from '../../../validation/validateHttpResponse'
import { Contract } from '../../../domain/models/ContractsModel'

export interface CancelContract {
  cancel(id: string): Promise<Contract>
}

export class RemoteCancelContract implements CancelContract {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  @validateHttpStatus
  async cancel(id: string): Promise<Contract> {
    const httpResponse = await this.httpClient.post?.({
      url: `${this.url}/${id}/cancel`
    })

    return httpResponse
  }
}
